import React, {useState, useEffect} from 'react';
import {Table, Button, Tag, Popover} from 'antd';
import {EyeOutlined} from '@ant-design/icons';
import {useNavigate, useParams} from 'react-router-dom';
import {
  PageSizeArray,
  PaginationPosition,
  CronJobStatus,
  formatDataForScheculer,
  getEmailDetails,
  renderTemplateChapterIdsCell,
  renderTemplateRunStatus,
} from '../../../Util/commonUtility';
import DynamicSearchForm from '../../CommonComponents/DynamicSearch';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import {useSelector} from 'react-redux';
import HeaderSearchCard from '../../CommonComponents/HeaderSearchCard';
import {CREATE} from '../../../Constant/enums';
import useLocalization from '../../../Localization';

const EventTemplateSchedulerComponent = (props) => {
  const {id} = useParams();
  const {ApplicationString} = useLocalization();

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const editTemplateParams = 'updateTemplate';
  const editTeplateSchedulerParams = 'updateTemplateSchedule';
  const toggleExpand = () => {
    // setExpanded(!expanded);
    navigate('/admin/events');
  };
  const {
    allEventTemplateSchedulers,
    fetchEventTemplateSchedulers,
    eventTemplateSchedulerData,
    paging,
    handlePaginationChange,
    fetchEventTempaltesByEventId,
    DeleteEventTemplateScheduler,
    sortParams,
    handleTableChange,
    updateStatusById,
    handleEditTemplate,
    sendDirectEmailByTemplateId,
    chaptersList,
  } = props;
  const ps = useSelector(
    ({pageSizes}) => pageSizes.pageSizes.eventTemplateSchedulers,
  );
  const handleSearch = (values) => {
    fetchAds(values);
  };

  const handleEditClick = async (id) => {
    navigate(`/admin/eventEmailTemplatesScheduler/update/${id}`);
  };

  useEffect(() => {
    const perId = Number(id);
    if (perId) {
      fetchEventTempaltesByEventId(perId);
    }
    // else {
    //   setEventTemplateData(allEventTemplateSchedulers);
    // }
  }, [id]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const renderDefaultScheduleStatus = (cronJobStatus) => {
    const updatedStatus = +cronJobStatus;
    let color;
    let label;
    switch (updatedStatus) {
      case CronJobStatus.RUN_SUCCESSFULLY:
        color = 'green';
        label = 'Run successfully';
        break;
      case CronJobStatus.FAILED:
        color = 'red';
        label = 'Failed to run schedule';
        break;
      default:
        color = 'purple';
        label = 'Schedule not initiated yet';
    }
    return {color, label};
  };

  const renderScheduleStatus = (record) => {
    // Attendance reminders now use the same schedule status as other emails.
    // The 7-day / alternate "next schedule" status is disabled.
    // if (record?.email_template_type !== 'Event Attendance Reminder') {
    return renderDefaultScheduleStatus(record?.cron_job_status);
    // }
    //
    // const cronJobStatus = +record?.cron_job_status;
    //
    // if (!record?.schedule_date) {
    //   if (cronJobStatus === CronJobStatus.RUN_SUCCESSFULLY) {
    //     return {color: 'green', label: 'Run successfully'};
    //   }
    //
    //   if (cronJobStatus === CronJobStatus.FAILED) {
    //     return {color: 'red', label: 'Failed to run schedule'};
    //   }
    //
    //   return {color: 'purple', label: 'Schedule not initiated yet'};
    // }
    //
    // if (cronJobStatus === CronJobStatus.FAILED) {
    //   return {color: 'red', label: 'Failed to run schedule'};
    // }
    //
    // const scheduleState = record?.attendance_schedule_state;
    // const lastScheduledDate = scheduleState?.last_scheduled_date;
    // const nextScheduledDate = scheduleState?.next_scheduled_date;
    //
    // if (
    //   scheduleState?.schedule_meta?.last_run_reason ===
    //   'no_registered_recipients'
    // ) {
    //   return {
    //     color: 'green',
    //     label: 'Run successfully (No registered attendee was there)',
    //   };
    // }
    //
    // if (
    //   scheduleState?.is_completed &&
    //   lastScheduledDate &&
    //   !nextScheduledDate
    // ) {
    //   return {color: 'green', label: 'Run successfully'};
    // }
    //
    // if (lastScheduledDate && nextScheduledDate) {
    //   return {
    //     color: 'blue',
    //     label: `Ran at ${formatDataForScheculer(
    //       lastScheduledDate,
    //     )}, next schedule at ${formatDataForScheculer(nextScheduledDate)}`,
    //   };
    // }
    //
    // return {color: 'purple', label: 'Schedule not initiated yet'};
  };

  const tableScrollWidth = 1500;

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
      sorter: true,
    },
    // {
    //   title: 'Event ID',
    //   dataIndex: 'event_id',
    //   key: 'eventId',
    //   width: 100,
    // },
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
      width: 160,
      ellipsis: true,
      sorter: true,
    },
    {
      title: 'Email Code Template',
      dataIndex: 'email_template_body',
      key: 'email_template_body',
      width: 200,
      sorter: false,
      render: (text) => {
        const html = {__html: text};
        return (
          <div className='fixed-size-text'>
            <Popover
              prefixCls='extend-popover-event-temaplate'
              content={
                <div
                  className='pop-over-scroll'
                  dangerouslySetInnerHTML={html}></div>
              }
              trigger='hover'
              title='Description'
              arrow={false}>
              <Button type='text' prefixCls='common-button-popover'>
                <EyeOutlined /> View
              </Button>
            </Popover>
          </div>
        );
      },
    },
    {
      title: 'User Group',
      dataIndex: 'email_template_type',
      key: 'email_template_type',
      sorter: false,
      width: 300,
      render: (text) => {
        const emailDetails = getEmailDetails(text);
        return (
          <div
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: 1.4,
            }}>
            {emailDetails.description}
          </div>
        );
      },
    },
    {
      title: 'Local Chapter',
      dataIndex: 'local_chapter_ids',
      key: 'local_chapter_ids',
      sorter: false,
      width: 110,
      render: (chapterIds, record) =>
        renderTemplateChapterIdsCell(
          chapterIds,
          chaptersList,
          record?.email_template_type,
          'Local Chapter',
        ),
    },
    {
      title: 'Mail Preference',
      dataIndex: 'mail_preference_chapter_ids',
      key: 'mail_preference_chapter_ids',
      sorter: false,
      width: 120,
      render: (chapterIds, record) =>
        renderTemplateChapterIdsCell(
          chapterIds,
          chaptersList,
          record?.email_template_type,
          'Mail Preference',
        ),
    },
    {
      title: 'Schedule Date',
      dataIndex: 'schedule_date',
      key: 'schedule_date',
      sorter: true,
      width: 170,
      render: (_, record) => {
        let scheduleDate;
        if (record?.schedule_date)
          scheduleDate = formatDataForScheculer(record?.schedule_date);
        else scheduleDate = 'Email not scheduled';
        return (
          <Tag color={'success'} className='date-common-tag'>
            {`${scheduleDate}`}
          </Tag>
        );
      },
    },
    {
      title: 'Schedule Status',
      dataIndex: 'cron_job_status',
      key: 'cron_job_status',
      width: 240,
      sorter: false,
      render: (_, record) => {
        const {color, label} = renderScheduleStatus(record);
        return renderTemplateRunStatus(
          <Tag
            color={color}
            style={{
              margin: 0,
              whiteSpace: 'normal',
              lineHeight: '20px',
            }}>
            {label}
          </Tag>,
          record,
        );
      },
    },
    {
      title: '',
      key: 'action',
      width: 70,
      fixed: 'right',
      render: (_, record) => (
        <AdminActionsDropdown
          record={record}
          editBool={false}
          deleteBool={true}
          sendDirectEmail={true}
          viewEventEmailTemplateScheduler={true}
          handleViewEventEmailTemplateScheduler={(rowRecord) => {
            const url = `/admin/eventEmailTemplate/preview/${rowRecord?.event_id}/${rowRecord?.id}`;
            window.open(url, '_blank');
          }}
          resource='events_email_scheduler'
          handleDeleteClick={DeleteEventTemplateScheduler}
          handleSendDirectEmailClick={sendDirectEmailByTemplateId}
          text='Event Template Scheduler'
          handleEditTemplate={(stateValue, id) => {
            handleEditTemplate(stateValue);
            navigate(
              `/admin/eventEmailTemplatesScheduler/update/${id}/${record?.event_id}/${editTemplateParams}`,
            );
          }}
          handleEditSchedule={(stateValue, id) => {
            handleEditTemplate(stateValue);
            navigate(
              `/admin/eventEmailTemplatesScheduler/update/${id}/${record?.event_id}/${editTeplateSchedulerParams}`,
            );
          }}
        />
      ),
    },
  ];

  // Apply sorting to columns
  columns.forEach((column) => {
    if (column.key !== 'action') {
      column.sortOrder =
        sortParams.field === column.dataIndex && sortParams.order;
    }
  });

  return (
    <div className='main-container'>
      <HeaderSearchCard
        resource='events_email_scheduler'
        buttonTitle={ApplicationString['eventTemplateScheduler.button.addForm']}
        addClick={() =>
          navigate(`/admin/eventEmailTemplatesScheduler/add/${id}`)
        }
        dataTestId='adminEventEmailSchedulers-button-addEventEmailSchedulers'
        permission={CREATE}
        showFilter={false}
        extra={
          <>
            <Button
              onClick={toggleExpand}
              id='EventTemplateSchedulerComponent-button-filterSearch'>
              {/* {expanded ? <FilterOutlined /> : <FilterOutlined />}{' '}
          {ApplicationString['dynamicSearch.button.heading']} */}
              Back To Events
            </Button>
          </>
        }
      />
      {expanded && (
        <DynamicSearchForm columns={columns} onSearch={handleSearch} />
      )}
      <div className='listing-container'>
        <Table
          bordered
          className='admin-table'
          columns={columns}
          onChange={handleTableChange}
          dataSource={eventTemplateSchedulerData}
          rowKey={(record) => record.id}
          sticky={true}
          tableLayout='fixed'
          scroll={{x: tableScrollWidth}}
          pagination={{
            onChange: (page, pageSize) => {
              handlePaginationChange(page, pageSize);
            },
            current: paging.page,
            total: paging.totalCount,
            pageSize: ps || paging.pageCount,
            pageSizeOptions: PageSizeArray,
            showSizeChanger: true,
            onShowSizeChange: (page, pageSize) => {
              handlePaginationChange(page, pageSize);
            },
            showTotal: (total, range) => `Total ${total} items`,
            position: [PaginationPosition],
          }}
        />
      </div>
    </div>
  );
};

export default EventTemplateSchedulerComponent;
